import {Component, ElementRef, forwardRef, Inject, OnInit, ViewChild} from '@angular/core';
import {getAuthorizeToken, IKnowAuthorization, SessionEventNotificationService} from '@westjetairlines/wjesd-oauth2-library';
import {DateUtil} from "@westjetairlines/wjesd-component-library";

@Component({
  selector: 'app-session-notification-message',
  templateUrl: './session-notification-message.component.html',
  styleUrls: ['./session-notification-message.component.css']
})
export class SessionNotificationMessageComponent implements OnInit {
  @ViewChild('sessionExpiringAlert') sessionExpiringAlert: ElementRef;
  @ViewChild('sessionExpiredAlert') sessionExpiredAlert: ElementRef;
  message: string = "";

  constructor(private sessionEventNotificationService: SessionEventNotificationService,
              @Inject(forwardRef(() => getAuthorizeToken)) private authService: IKnowAuthorization) {

    sessionEventNotificationService.sessionExpired$.subscribe(() => this.showSessionExpired());
    sessionEventNotificationService.sessionExpiring$.subscribe((data: Date) => {
      this.showSessionExpiring(data);
    });
  }

  ngOnInit() {
  }

  showSessionExpiring(expiryTime: Date) {
    this.message = `Your session will expire on ${DateUtil.toLongFormat(expiryTime)}. You will need to log out and sign in again.`;
    this.sessionExpiringAlert.nativeElement.click();
  }

  showSessionExpired() {
    this.message = `Your session has expired and you have been signed out.`;
    this.sessionExpiredAlert.nativeElement.click();
  }

  onSessionExpiredOk() {
    this.authService.logOut();
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/session-notification-message/session-notification-message.component.ts